<template>
	<div id="app" :class="stage.loc.customer">
		<PrivacyTips ref="privacyTips"></PrivacyTips>
		<div id="svg" class="dpN"></div>
		<WindowForAlert :title="announcement.title" :btnClose="false" :btnCancel="false" :size="'m'" ref="Window">
			<div v-html="announcement.content"></div>
			<template slot="btmBtn">
				<a v-if="announcement.buttonLink" :href="announcement.buttonLink" target="_blank" class="functionBtn dpIB sizeM-lh" @click="passAnnouncement">{{
					announcement.buttonName
				}}</a>
				<button v-else class="functionBtn" @click="passAnnouncement" type="button">{{ announcement.buttonName }}</button>
			</template>
		</WindowForAlert>
		<router-view></router-view>
	</div>
</template>

<script>
import { windowCtrl, fillHeight, formModeChange, getCookie, setCookie } from "@/util/lib.js";
import { apiAnnouncement, apiUpdateVersion } from "@/api/base.js";
import PrivacyTips from "@/view/frame/PrivacyTips.vue";
import * as lib from "@/util/lib.js";

export default {
	name: "app",
	components: { PrivacyTips },
	data() {
		return {
			stage,
			announcement: {},
		};
	},
	created() {
		$("head title").html(stage.loc.customerDisplay[stage.languageId] || stage.loc.customerDisplay.public);
		//百度统计代码
		if (stage.loc.statistic.baidu) {
			window._hmt = window._hmt || [];
			(function () {
				var hm = document.createElement("script");
				hm.src = stage.loc.statistic.baidu;
				var s = document.getElementsByTagName("script")[0];
				s.parentNode.insertBefore(hm, s);
			})();
		}
	},
	methods: {
		getAnnouncement: function () {
			//获取公告
			setTimeout(() => {
				if (!stage.setting.loc.shieldWhiteList.Announcement) return;
				apiAnnouncement().then((success) => {
					this.announcement = success;
					if (success.id) {
						if (!getCookie(`announcement${this.announcement.id}`)) {
							this.$refs.Window.show();
						}
					}
				});
			}, 0);
		},
		passAnnouncement: function () {
			//记录公告cookie并关闭公告窗口
			setCookie(`announcement${this.announcement.id}`, "pass");
			this.$refs.Window.hide();
		},
	},
	mounted() {
		let that = this;
		$("<div></div>").load(`${stage.loc.baseRouter}static/image/ui.svg?v=${stage.ver}`, function (data) {
			$(data)
				.find("symbol")
				.not("[id='logo']")
				.each(function () {
					$(this)
						.find("[stroke]")
						.each(function () {
							if ($(this).attr("stroke") == "#000") $(this).removeAttr("stroke");
						});
				});
			$("#svg").append(data);
		});

		$(document).on("click", ".window .body,.window .guide", function (e) {
			e.stopPropagation();
		});
		$(document, "[onclick]").on("click", "a,button,label", function (e) {
			//所有交互元素不冒泡
			e.stopPropagation();
		});

		$(document).on("click", ".window-view li[mode] .title", function () {
			//处理详情面板内的分类内容收起和展开以及编辑状态的控制
			let $root = $(this).parents("li").first();
			let mode = $root.attr("mode");
			switch (mode) {
				case "min":
					$root.attr("mode", "def");
					$root
						.children(".content")
						.stop()
						.slideDown(500, "easeInOutExpo", function () {
							$root.children(".content").css("height", ""); //不清空会残留高度影响内部的高度动画
						});
					break;
				case "def":
					$root.attr("mode", "min");
					$root.children(".content").stop().slideUp(500, "easeInOutExpo");
					break;
			}
		});
		$(document).on("click", ".window-view li[mode] .modeCtrl button", function () {
			//处理详情面板中编辑状态
			if ($(this).hasClass("save") == false) formModeChange(this); //保存动作由组件自己触发
		});
		$(document).on("click", ".window-view li[mode] .content-edit button,.window-view li[mode] .content-edit a", function () {
			//详情面板中编辑板块里按钮动作需要检查高度并修正
			let $btn = $(this);
			let $group = $btn.parents(".content").first().find(".changeGroup");
			setTimeout(function () {
				$group.css("height", $group.find(".content-edit").innerHeight());
			}, 500);
		});

		$(document).on("click", "button", function () {
			//解决点击按钮后，按回车依然可以触发事件
			if ($(this).is("[id*='help']") == false) {
				//排除帮助功能按钮
				$("body").append(`<button id="fireFocus" style="position:absolute;opacity:0;">a</button>`);
				$("#fireFocus").focus();
				$("#fireFocus").remove();
			}
		});

		$(document).on("mouseenter", ".hasDropList-hover", function () {
			//处理所有下拉位置修正
			if ($(this).hasClass(".select") == false) {
				//select组件有自己的修正
				if (($(this).parents(".window-alert").length || $(this).parents(".mCSB_container").length) && !$(this).addClass("fixedMode")) {
					$(this).addClass("fixedMode");
				}
				let $dropList = $(this).find(".dropList");
				// 上下修正
				let dropH = $dropList.innerHeight();
				let t = $(this).offset().top + $(this).find(".selectDisplay").innerHeight();
				if (t + dropH + stage.space > $(window).height()) {
					$(this).addClass("dropList-dropUp");
				} else {
					$(this).removeClass("dropList-dropUp");
				}
				// 左右修正
				let dropW = $dropList.innerWidth();
				let l = $(this).offset().left;
				if (l + dropW > $(window).width()) {
					$dropList.addClass("dropList-right").css({ left: "" });
				} else {
					$dropList.removeClass("dropList-right");
				}
			}
		});

		$(window).resize(function () {
			that.$bus.$emit("monResize");
			that.$bus.$emit("resizePB");
			fillHeight(500);
		});
		if (this.$route.path.indexOf("/tool") !== 0 && stage.useMode != "independentPage") {
			apiUpdateVersion();
			this.getAnnouncement();
		}
	},
};
</script>



// WEBPACK FOOTER //
// src/App.vue